<template>
  <div class="mc-signup-form">
    <link href="//cdn-images.mailchimp.com/embedcode/slim-10_7.css" rel="stylesheet" type="text/css">
    <div id="mc_embed_signup">
      <form id="mc-embedded-subscribe-form"
            :action="`https://muzik.us16.list-manage.com/subscribe/post?u=ee724027df7f3c26f778e1413&amp;id=${audienceId}`"
            method="post" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate
      >
        <div id="mc_embed_signup_scroll">
          <div class="title">
            {{ $t('EDM.TITLE') }}
          </div>
          <label for="mce-EMAIL">
            Email
          </label>
          <input id="mce-EMAIL" type="email" value="" name="EMAIL" class="email" required>
          <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
          <div style="position: absolute; left: -5000px;" aria-hidden="true">
            <input type="text" :name="`b_ee724027df7f3c26f778e1413_${audienceId}`" tabindex="-1" value="">
          </div>
          <div class="clear">
            <input id="mc-embedded-subscribe" type="submit" :value="$t('EDM.SUBSCRIBE')" name="subscribe" class="button">
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MCSignupForm',
  props: {
    audienceId: {
      type: String,
      default: 'a74d7315bc' // member_all_1
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
#mc_embed_signup {
  border-radius: 4px;
  background-image: url('/img/edm/img-edm.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  clear: left;
  color: #ffffff;
  font-family: NotoSansCJKtc;
  font-weight: 500;
  #mc_embed_signup_scroll {
    padding: 25px 0 0 10px;
  }
  .title {
    font-size: 20px;
    margin-bottom: 16px;
  }
  .form-control {
    font-family: NotoSansCJKtc;
    font-size: 16px;
    font-weight: bold;
    width: 90%;
    height: 44px;
    border-radius: 4px;
  }
  .email {
    @extend .form-control;
    border-color: $grey-ec;
    color: $grey-50;
    margin-bottom: 16px;
    &:focus {
      outline: none;
    }
  }
  .button {
    @extend .form-control;
    background-color: $theme-yellow;
  }
  label {
    font-size: 12px;
    font-weight: 500;
  }
}
@media only screen and (max-width: 1023.98px) {
  #mc_embed_signup {
    #mc_embed_signup_scroll {
      width: 100%;
      padding: 25px 0 0 0;
    }
    .email {
      border: 0;
      border-radius: 4px 0 0 4px;
      display: inline-block;
      margin: 0;
      width: 75%;
    }
    .button {
      border-radius: 0 4px 4px 0;
      display: inline-block;
      width: 20%;
    }
  }
}
@media only screen and (max-width: 767.98px) {
  #mc_embed_signup {
    .email {
      width: 70%;
    }
    .button {
      min-width: 25%;
    }
  }
}
</style>
